import { WifiOff, RefreshCw } from 'lucide-react';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

export default function OfflineBanner() {
  const status = useNetworkStatus();

  if (status !== 'offline') return null;

  const handleReload = () => globalThis.location.reload();

  // Offline — full overlay
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/95 backdrop-blur-sm px-8"
    >
      <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-6">
        <WifiOff className="w-10 h-10 text-gray-400" />
      </div>

      <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
        No Internet Connection
      </h2>

      <p className="text-sm text-gray-500 text-center max-w-xs mb-8">
        Looks like you're on a slow network or offline. Check your connection and try again.
      </p>

      <button
        onClick={handleReload}
        className="flex items-center gap-2 bg-brand-primary hover:bg-brand-hover active:bg-brand-active text-white font-medium px-8 py-3 rounded-lg transition-colors shadow-md"
      >
        <RefreshCw className="w-4 h-4" />
        Try Again
      </button>
    </div>
  );
}
